import React from "react"
import { Link, graphql } from "gatsby"
import Img from "gatsby-image"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import BlockHeader from "../components/blockheader"

function AboutCard(props) {
  return (
    <div className="w-full md:w-1/3 p-4 flex flex-col flex-grow flex-shrink">
      <div className="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow">
        <a href="#" className="flex flex-wrap no-underline hover:no-underline justify-center">

          <div className="w-full font-bold text-2xl text-gray-800 px-6 mt-2">
            {props.title}
          </div>
          <p className="w-full text-gray-600 text-base px-6 mb-5 mt-2">
            {props.message}
          </p>
        </a>
      </div>
      <div className="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow p-6">
        <div className="flex items-center justify-start">
          <Link to={props.destination}>
            <buttons className="mx-auto lg-mx-0 cursor-pointer hover:underline text-gray-800 font-extrabold rounded my-7 py-4 px-8 shadow-lg">
              {props.action}
            </buttons>
          </Link>
        </div>
      </div>
    </div>
  )
}

function ArticleCard(props){
  return(
    <ul className="md:w-1/2 px-4 border-gray-600 border-b pb-6 pt-6">
      <div className="flex items-center">
        {props.icon}
        <h3 className="font-bold text-xl text-bold mb-2">{props.title}</h3>
      </div>
      <p className="text-sm">{props.description}</p>
      <div className="flex items-center py-3">
        <svg className="h-6 pr-3 fill-current text-blue-300"
          xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
          <path d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"/>
        </svg>
        <Link to={props.destination} className="bold border-b-2 border-blue-300 hover:text-blue-300">Read more</Link>
      </div>
    </ul>
  )
}

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title="Web Content Creators Association"
        />
        <div className="container mx-auto max-w-5xl">
          <h1 className="my-4 text-2xl md:text-3xl lg:text-5xl font-black leading-tight">
            Web Content Creators Association
          </h1>
          <p className="leading-normal text-gray-800 text-base md:text-xl lg:text-2xl mb-8">
            Furthering the professionalism, recognition, and excellence of content creators.
          </p>
        </div>
        <section className="bg-gray-100 border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap pt-4 pb-12">
            <AboutCard
              title="Our Mission"
              message="The WCCA works to further the professionalism, recognition, and excellence of content creators. We accomplish this with our Code of Conduct, our advocacy efforts, and our training endeavours."
              action="Learn More"
              destination="/about"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 640 640"><path d="M198.652 621.563c0-55.1 30.284-81.036 70.123-110.93V366.478L7.145 482.712c0-100.608-34.24-93.237 47.116-144.356l.803-.496v-62.871h58.418v26.48l42.922-26.74v-70.442h58.418v34.052l53.953-33.615V55.891c0-20.93 22.737-38.043 50.528-38.043h.012c27.792 0 50.528 17.15 50.528 38.043v148.833l54.532 33.97v-34.407h58.418v70.796l42.934 26.73v-26.824h58.406v63.213c81.025 50.34 50.068 40.513 50.068 144.51L369.843 366.325V509.95c42.39 28.3 70.11 49.985 70.11 111.616l-66.697.58c-15.26-12.001-25.854-21.096-33.98-27.391-6.142 2.008-12.898 3.118-19.961 3.118h-.012c-7.985 0-15.58-1.417-22.312-3.933-8.752 6.378-20.338 15.815-37.547 28.205l-60.792-.579z"/></svg>
              }
            />
            <AboutCard
              title="Our Members"
              message="We are professional content creators dedicated to delivering quality content to our audiences. We believe in communicating to the world and continuously developing ourselves."
              action="Join us"
              destination="/membership"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 1333.34 1332.32" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"><path d="M323.23 644.52c39.44 71.14 84.87 139.46 144.04 201.8 59.17 62.69 132.77 119.74 228.21 168.34 7.04 3.52 13.73 3.52 19.72 1.06 9.16-3.52 18.32-10.92 27.47-20.07 7.05-7.05 15.85-18.32 25-30.64 36.63-48.25 82.06-108.12 146.15-78.19 1.41.7 2.47 1.41 3.87 2.11l213.77 122.91c.7.35 1.41 1.06 2.11 1.41 28.17 19.37 39.8 49.31 40.15 83.12 0 34.51-12.68 73.25-31.34 106-24.65 43.31-60.93 71.84-102.83 90.85-39.8 18.31-84.17 28.18-126.79 34.52-66.91 9.86-129.6 3.52-193.69-16.2-62.69-19.36-125.73-51.42-194.75-94.03l-4.93-3.17c-31.69-19.72-65.85-40.85-99.31-65.85-122.91-92.63-247.93-226.45-329.28-373.66C22.47 651.22-14.86 517.74 5.57 390.61c11.28-69.73 41.2-133.12 93.33-175.03 45.43-36.63 106.71-56.7 185.95-49.66 9.16.7 17.25 5.99 21.48 13.73l137 231.73c20.08 26.06 22.54 51.78 11.62 77.48-9.16 21.13-27.47 40.5-52.48 58.82-7.39 6.34-16.2 12.68-25.35 19.37-30.64 22.19-65.5 47.89-53.54 78.18l-.35-.7zm847.74-449.2c28.14 0 50.95 22.82 50.95 50.96s-22.81 50.95-50.95 50.95c-28.14 0-50.96-22.81-50.96-50.95 0-28.14 22.82-50.96 50.96-50.96zm-349.6-.19c28.21 0 51.07 22.86 51.07 51.06 0 28.2-22.87 51.05-51.07 51.05-28.21 0-51.05-22.85-51.05-51.05 0-28.2 22.83-51.06 51.05-51.06zm181.06 0c28.21 0 51.07 22.86 51.07 51.06 0 28.2-22.87 51.05-51.07 51.05-28.21 0-51.05-22.85-51.05-51.05 0-28.2 22.84-51.06 51.05-51.06zM792.23 0c-38.16 0-70.83 13.43-98 40.3-27.17 26.87-40.3 59.53-40.3 98v242.71c0 38.46 13.43 71.13 40.3 98 26.87 26.87 59.53 40.3 98 40.3h113.63c-7.93 30.53-17.7 59.53-29.91 86.7-11.91 27.48-32.36 53.73-60.45 78.77 54.04-14.04 101.97-35.11 144.41-62.89 42.13-27.48 78.77-61.98 108.99-102.58h126.15c38.16 0 70.83-13.74 98-40.3 27.17-26.87 40.29-59.54 40.29-98V138.3c0-38.17-13.43-70.83-40.29-98-26.87-27.17-59.53-40.3-98-40.3H792.24z" fill-rule="nonzero"/></svg>
              }
            />
          </div>
        </section>
        <section className="border-b py-8">
          <div className="container mx-auto max-w-5xl flex flex-wrap justify-center mx-2">
            <div className="w-full font-bold text-2xl text-gray-800 px-6 pb-4 mt-2">
              <h2>Recent Articles From Our Members</h2>
            </div>
            <ArticleCard
              title="What Content Creator Degrees Employers Ask For"
              destination="/content-creator-degree-types"
              description="Using the results of a survey, I found that most jobs do NOT require a degree. Out of those that do, I've looked at what are the useful degrees for being a Content Creator"
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M2 4v14h14v-6l2-2v10H0V2h10L8 4H2zm10.3-.3l4 4L8 16H4v-4l8.3-8.3zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z"/>
                </svg>
              }
            />
            <ArticleCard
              title="Is Being a Content Cretor a Real Job?"
              destination="/content-creator-real-job"
              description="I surveyed dozens of job descriptions to show that YES, being a Content Creator can be a real full-time job."
              icon={
                <svg className="h-8 mb-3 mr-3 fill-current text-gray"
                  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M3 6c0-1.1.9-2 2-2h8l4-4h2v16h-2l-4-4H5a2 2 0 0 1-2-2H1V6h2zm8 9v5H8l-1.67-5H5v-2h8v2h-2z"/>
                </svg>
              }
            />
          </div>
        </section>
        
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    avatar: file(absolutePath: { regex: "/me_hkg__43_750.jpg/" }) {
      childImageSharp {
        fixed(width: 132, height: 86) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        title
        siteUrl
        author
      }
    }
    file(absolutePath: { regex: "/splash.jpg/" }) {
      childImageSharp {
        fluid (maxWidth: 786){
          ...GatsbyImageSharpFluid
        }
      }
    }
    back_one: file(absolutePath: { regex: "/background_one.jpg/" }) {
      childImageSharp {
        fluid (maxHeight: 240) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    back_two: file(absolutePath: { regex: "/background_two.jpg/" }) {
      childImageSharp {
        fluid (maxHeight: 240) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC } limit:3) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            cover_image {
              childImageSharp {
                resize (width:1500, height: 1500) {
                  src
                }
                fluid (maxWidth: 786) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            cover_image_caption
          }
        }
      }
    }
  }
`
